enum ReportTemplate {
  ASSET = 'ASSET',
  ASSET_LIST = 'ASSET_LIST',
  BEST_SOLUTION_LIST = 'BEST_SOLUTION_LIST',
  DASHBOARD = 'DASHBOARD',
  EXECUTIVE_SUMMARY = 'EXECUTIVE_SUMMARY',
  EXPLOIT_LIST = 'EXPLOIT_LIST',
  MALWARE_LIST = 'MALWARE_LIST',
  NEW_VULNERABILITY_LIST = 'NEW_VULNERABILITY_LIST',
  REMEDIATED_VULNERABILITY_LIST = 'REMEDIATED_VULNERABILITY_LIST',
  SERVICE_LIST = 'SERVICE_LIST',
  SOFTWARE_LIST = 'SOFTWARE_LIST',
  VULNERABILITY = 'VULNERABILITY',
  VULNERABILITY_LIST = 'VULNERABILITY_LIST',
  BULK_REMEDIATION_LIST = 'BULK_REMEDIATION_LIST',
}

export const ReportTemplates = Object.values(ReportTemplate);

export default ReportTemplate;
